import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/validator-infrastructure/page.tsx");
